function Loader(){
    return(
        <>
        <div className="nloader">
            <div className="w-24 h-24 border-2 m-2 border-b-transparent border-orange-500 animate-spin rounded-full">
                <div className=" w-[80px] h-[80px] border-2 m-2 border-r-transparent border-orange-600 animate-reverse-spin rounded-full">
                    <div className="w-[60px] h-[60px] border-2 m-2 border-t-transparent border-orange-700 animate-spin rounded-full"></div>
                </div>
            </div>
        </div>
        </>
    )
}

export default Loader;